import { FC } from 'react';

import { AppFormattedMessage } from '../../../../../components/app-formatted-message/index';
import { VestingGraphSubtitlePart } from '../model/vesting-graph.types';

export const VestingGraphSubtitle: FC<{ parts: VestingGraphSubtitlePart[] }> = ({ parts }) => (
  <>
    {parts.map((part, index) => (
      <span key={part.id}>
        {index > 0 && ', '}
        <AppFormattedMessage id={part.id} values={part.values} />
      </span>
    ))}
  </>
);
